<template>
  <div class="w-full h-full overflow-hidden">
    <div id="previewpage" class="flex w-full h-full">
      <div class=""></div>
      <div id="page-profil" class="h-full w-full flex-shrink-0  relative transition-next">
        <div class="h-full relative">
          <div class="h-[10%] bg-[#F8F8F8] w-full flex items-center">
            <div class="w-full justify-between md:px-3 flex mt-1">
              <div class="flex justify-between md:justify-normal w-full md:w-auto">
                <div class="flex space-x-2 px-2 md:px-4  md:border-r-[1px] border-gray-300">
                  <div v-if="user == ''" class=" rounded-full w-10 h-10 overflow-hidden bg-gray-300 animate-pulse"></div>
                  <div v-if="user" class=" rounded-full w-10 h-10 overflow-hidden bg-white flex items-center">
                    <img v-if="user.avatar" class="w-full h-full object-cover object-center rounded-full "
                      :src="user.avatar" alt="" srcset="">
                    <img v-if="user.avatar == '' || user.avatar == null"
                      class="w-7 h-7 mx-auto object-cover object-center rounded-full " src="/logo/mel_logo_noir.png"
                      alt="" srcset="">
                  </div>
                  <div class="h-auto mt-auto mb-auto">
                    <p v-if="user == ''" class=" font-semibold w-[4.5rem] h-4 bg-gray-300 animate-pulse"></p>
                    <div v-if="user == ''" class="flex space-x-1 mt-1">
                      <button>
                        <svg class="w-4 h-4 fill-gray-500 animate-pulse" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                          <g id="surface1">
                          <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                          </g>
                        </svg>
                      </button>
                      <button>
                        <svg class="w-4 h-4 fill-gray-500 animate-pulse" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                          <g id="surface1">
                          <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                          </g>
                        </svg>
                      </button>
                      <button>
                        <svg  class="w-4 h-4 fill-gray-500 animate-pulse" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                          <g id="surface1">
                          <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                          </g>
                        </svg>
                      </button>
                      <button>
                        <svg class="w-4 h-4 fill-gray-500 animate-pulse" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                          <g id="surface1">
                          <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                          </g>
                        </svg>
                      </button>
                      <button>
                        <svg  class="w-4 h-4 fill-gray-500 animate-pulse" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                          <g id="surface1">
                          <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                          </g>
                        </svg>
                      </button> 
                    </div>
                    <div v-if="user" class="h-auto">
                      <p class=" font-semibold">{{ user.name }}</p>
                    </div>
                    <div v-if="user" class="flex space-x-1">
                        <div>
                          <svg :class="Math.round(user.etoile/user.avis) >= 1 ? 'fill-[#ff9900]' : 'fill-[#8A8A8A]'" class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                            <g id="surface1">
                            <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                            </g>
                          </svg>
                        </div>
                        <div>
                          <svg :class="Math.round(user.etoile/user.avis) >= 2 ? 'fill-[#ff9900]' : 'fill-[#8A8A8A]'" class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                            <g id="surface1">
                            <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                            </g>
                          </svg>
                        </div>
                        <div>
                          <svg :class="Math.round(user.etoile/user.avis) >= 3 ? 'fill-[#ff9900]' : 'fill-[#8A8A8A]'" class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                            <g id="surface1">
                            <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                            </g>
                          </svg>
                        </div>
                        <div>
                          <svg :class="Math.round(user.etoile/user.avis) >= 4 ? 'fill-[#ff9900]' : 'fill-[#8A8A8A]'" class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                            <g id="surface1">
                            <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                            </g>
                          </svg>
                        </div>
                        <div>
                          <svg :class="Math.round(user.etoile/user.avis) >= 5 ? 'fill-[#ff9900]' : 'fill-[#8A8A8A]'" class="w-4 h-4" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                            <g id="surface1">
                            <path style=" stroke:none;fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                            </g>
                          </svg>
                        </div> 
                    </div>
                  </div>
                  <div class="h-auto flex items-center">
                    <div v-if="user == ''" class="w-5 h-5 mx-auto bg-gray-300 animate-pulse rounded-full"></div>
                    <img v-if="user.type != 0" class="w-5 h-5 mx-auto object-cover object-center rounded-full "
                      src="/icons/approval2.png" alt="" srcset="">
                  </div>
                </div>
                <div class="flex space-x-6 h-auto items-center px-2 md:px-4">
                  <div class="md:flex md:items-center hidden">
                    <div v-if="user == ''" class="w-6 h-6 mx-auto bg-gray-300 animate-pulse rounded-full"></div>
                    <img v-if="user" class="md:w-6 md:h-6 h-4 hidden md:block" src="/icons/icons8_slide_up@2x.png" alt=""
                      srcset="">
                    <img v-if="user" class="md:w-6 md:h-6 h-4 md:hidden" src="/icons/chevronuporange.png" alt=""
                      srcset="">
                    <p v-if="user == ''" class=" font-semibold ml-1 w-[5rem] h-2 bg-gray-300 animate-pulse"></p>
                    <p v-if="user" class="text-xs md:text-base ml-1">{{ user.nbr_suiveur }} {{ $t('abonnes') }}</p>
                  </div>
                  <div class="flex top-5 left-10">
                    <div class="flex justify-end md:justify-start items-center w-32 md:w-44">
                      <div v-if="!loadingVerify"
                        class=" rounded-md w-32 md:w-44 h-8 overflow-hidden bg-gray-300 animate-pulse"></div>
                      <div v-if="user && verifAbonnement && loadingVerify" class="transition-all duration-1000 text-[#1D04FF] space-x-1 w-32 md:w-44 h-8 bg-transparent rounded-md relative  border-[#1D04FF]">
                        <div @click="showDesabonnee = !showDesabonnee" class="w-full space-x-1 cursor-pointer h-full flex items-center justify-center" v-if="verifAbonnement">
                          <div class="h-auto flex items-center">
                            <img class="w-5 h-5" src="/icons/follower.png" alt="" srcset="">
                          </div>
                          <div class="h-auto flex items-center">
                            <p id="message" class="message text-xs md:text-base">{{ $t('sedesabonne') }}</p>
                          </div>
                        </div>
                        <div v-if="showDesabonnee" class="w-full h-10 relative">
                          <div class="w-full h-full bg-white rounded-bl-md rounded-br-md shadow shadow-black absolute z-50 divide-x divide-gray-400 flex overflow-hidden">
                            <div @click="Desabonnee" class="flex-auto h-full cursor-pointer flex text-black hover:bg-green-500 hover:text-white transition-all duration-700 items-center justify-center">
                              <p class="text-lg">Oui</p>
                            </div>
                            <div @click="showDesabonnee = !showDesabonnee" class="flex-auto h-full cursor-pointer flex text-black hover:bg-red-500 hover:text-white transition-all duration-700 items-center justify-center">
                              <p class=" text-lg">Non</p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="user && !verifAbonnement && loadingVerify" :class="myAccount.status == 'block' ? 'opacity-50':'opacity-100'" class="  text-white w-32 md:w-44 h-8 bg-[#1D04FF] rounded-md transition-all duration-1000 cursor-pointer relative">
                        <button @click="Abonnement" :disabled="myAccount.status == 'block'? true:false" class="w-full h-full flex items-center justify-center" v-if="verifAbonnement == false">
                          <img id="icon-abonne" class="w-0 h-0 transition-all duration-[5000ms]" src="/icons/follower.png" alt="" srcset="">
                          <p id="message" class="message text-xs md:text-base">{{ $t('suivrecetteboutique') }}</p>
                          <div id="check" class="h-0 border-white transition-all duration-1000"></div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="md:flex items-center hidden space-x-2">
                <div class=" flex space-x-2">
                  <div class="h-auto flex items-center">
                    <p v-if="user == ''" class=" font-semibold ml-1 w-[8.5rem] h-2 bg-gray-300 animate-pulse"></p>
                    <p v-if="user" class="text-xs md:text-base ">{{ $t('niveau') }} {{ user.niveau }}<span class="ml-2">{{
                      user.point
                    }}
                        pts/100</span></p>
                  </div>
                  <div>
                    <div v-if="user == ''" class="w-9 h-9 mx-auto bg-gray-300 animate-pulse rounded-full"></div>
                    <CircleProgressBar v-if="user" class="w-9 h-9" :colorUnfilled="'#FF9900'" :strokeWidth="'10px'"
                      :animationDuration="'3s'" :value="user.point" :max="100">{{ user.niveau }}</CircleProgressBar>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="user" class="h-[90%] w-full flex">
            <div class="h-full xl:w-[20%] bg-[#FF9900] relative link">
              <div class="w-full absolute bottom-0 px-2 xl:px-0 flex space-x-2">
                <div class="w-[90%] mx-auto flex">
                  <img class="h-8 md:h-9" src="/logo/logo mel completement blanc.png" alt="" srcset="">
                  <div class="h-auto flex items-center">
                    <p class="text-white hidden xl:block text-sm mt-2">{{ $t('membredepuis') }} {{ JSON.parse($t('mois'))[new Date(user.created_at).getMonth()] }} {{ new Date(user.created_at).getFullYear() }}</p>
                  </div>
                </div>
              </div>
              <div class="w-full cursor-pointer xl:h-[12%] h-[8%] flex">
                <router-link :to="{name:'infoprofilother', query:{id:user.id, name: user.name} }" class=" w-full h-full flex xl:block px-3 mx-auto">
                  <div class=" h-full flex items-center mx-auto  space-x-4">
                    <img class="md:h-8  h-6 object-contain" src="/icons/icons8_male_user@2x.png" alt="" srcset="">
                    <p class="text-white hidden xl:block text-lg">{{ $t('compte') }}</p>
                  </div>
                </router-link>
              </div>
              <div class="w-full cursor-pointer xl:h-[12%] h-[8%] mt-2 md:mt-0 flex">
                <router-link :to="{name:'ses-articles', query:{id:user.id, name: user.name} }" class="w-full flex xl:block px-3 h-full mx-auto">
                  <div class="h-full flex items-center mx-auto space-x-4">
                    <img class="md:h-8 h-6 object-contain" src="/icons/icons8_sell@2x.png" alt="" srcset="">
                    <p class="text-white hidden xl:block xl:text-lg first-letter:uppercase">{{ $t('articles') }}</p>
                  </div>
                </router-link>
              </div>
            </div>
            <div class="h-full w-screen xl:w-[80%] relative">
              <div v-if="verifCommande" class="absolute backdrop-blur-sm w-full h-full z-40 flex justify-center items-center">
                <div class="w-[90%] md:w-1/2 bg-white rounded-lg shadow-black shadow-sm p-2 space-y-3">
                  <div class="w-full flex justify-end h-auto">
                    <svg @click="verifCommande=false" class="right-1 h-6 cursor-pointer" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"  viewBox="0 0 500 500" version="1.1">
                      <g id="surface1">
                      <path style=" stroke:none;fill-rule:nonzero;fill:#585555;fill-opacity:1;" d="M 76.574219 62.3125 L 62.3125 76.574219 L 233.753906 248.015625 L 62.3125 419.457031 L 76.574219 433.71875 L 248.015625 262.277344 L 419.457031 433.71875 L 433.71875 419.457031 L 262.277344 248.015625 L 433.71875 76.574219 L 419.457031 62.3125 L 248.015625 233.753906 Z "/>
                      </g>
                    </svg>                      
                  </div>
                  <div class="space-y-4">
                    <p class="text-center text-lg md:text-2xl">{{ $t('Combienetoilesdonneriezvous') }} <span class="text-black font-semibold">({{ user.name }})</span> ?</p>
                    <p class="text-center text-gray-500 text-sm md:text-md" >{{ $t('messagenotationpart1') }} {{ $t('messagenotationpart2') }}</p>
                  </div>
                  <div class="flex justify-center w-full">
                    <div class="flex space-x-1  justify-between">
                      <button>
                        <svg @click="Note(1)" @mouseover="note = 1"  :class="note >= 1 ? 'fill-[#ff9900]' : 'fill-transparent stroke-[3] stroke-[#FF9900]'" class="w-12 h-12" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                          <g id="surface1">
                          <path style=" fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                          </g>
                        </svg>
                      </button>
                      <button>
                        <svg @click="Note(2)" @mouseover="note = 2"  :class="note >= 2 ? 'fill-[#ff9900]' : 'fill-transparent stroke-[3] stroke-[#FF9900]'" class="w-12 h-12" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                          <g id="surface1">
                          <path style="fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                          </g>
                        </svg>
                      </button>
                      <button>
                        <svg @click="Note(3)" @mouseover="note = 3"  :class="note >= 3 ? 'fill-[#ff9900]' : 'fill-transparent stroke-[3] stroke-[#FF9900]'" class="w-12 h-12" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                          <g id="surface1">
                          <path style="fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                          </g>
                        </svg>
                      </button>
                      <button>
                        <svg @click="Note(4)" @mouseover="note = 4"  :class="note >= 4 ? 'fill-[#ff9900]' : 'fill-transparent stroke-[3] stroke-[#FF9900]'" class="w-12 h-12" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                          <g id="surface1">
                          <path style="fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                          </g>
                        </svg>
                      </button>
                      <button>
                        <svg @click="Note(5)" @mouseover="note = 5"  :class="note >= 5 ? 'fill-[#ff9900]' : 'fill-transparent stroke-[3] stroke-[#FF9900]'" class="w-12 h-12" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 96 96" version="1.1">
                          <g id="surface1">
                          <path style="fill-rule:nonzero;fill-opacity:1;" d="M 48 71.515625 L 75.328125 88 L 68.078125 56.921875 L 92.21875 36.015625 L 60.421875 33.3125 L 48 4 L 35.578125 33.3125 L 3.78125 36.015625 L 27.921875 56.921875 L 20.671875 88 Z "/>
                          </g>
                        </svg>
                      </button> 
                    </div>
                  </div>
                </div>
              </div>
              <router-view name="five"></router-view>
            </div>
          </div>
          <div v-if="user == ''" class="h-[90%] w-full flex bg-gray-300 animate-pulse">

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CircleProgressBar } from 'vue3-m-circle-progress-bar';
import { useRoute } from "vue-router"

export default {
  components: { CircleProgressBar },
  data() {
    return {
      user: '',
      myAccount:{},
      intervalTime: '',
      animeAbonnement: true,
      verifAbonnement:false,
      verifCommande:false,
      form:{
        langue:'',
      },
      showDesabonnee:false,
      loadingVerify:false,
      note:0
    }
  },
  beforeRouteLeave() {
      window.emitter.off("reloadProfil")
  },
  created(){
    window.emitter.on("reloadProfil", (id) => {
      this.user = '' 
      this.axios.get(this.requestHttp + 'viewprofil/' + id, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
        },
      }).then(({ data }) => {
        this.user = data[0]
        this.$store.state.viewProfil = data[0]
        this.verifAbonnement = data[1]
        this.verifCommande = data[2]
        this.loadingVerify = true
      })
      .catch((error) => {
        console.log(error)
      });
    })
  },
  mounted(){
    this.requestAuth == 'NotAuth' ? this.$router.push('/login'):''
    this.form.langue = localStorage.getItem('langue');
    var parent = document.getElementById('previewpage')
    if (this.$store.state.preview) {
      this.$store.state.preview.classList.remove('transition-next')
      parent.firstChild.className = 'preview-transition flex-shrink-0 w-full h-full flex'
      parent.firstChild.appendChild(this.$store.state.preview)
      document.querySelector(':root').style.setProperty('--tx', (document.getElementsByClassName('transition-next')[0].clientWidth) + 'px')
      document.querySelector(':root').style.setProperty('--ty', (document.getElementsByClassName('transition-next')[0].clientWidth * -1) + 'px')
    } else {
      parent.lastChild.classList.remove('transition-next')
    }
    this.$store.state.preview = parent.lastChild

    this.myAccount = this.$store.state.dataAccueil[0]
    var route = useRoute()
    if(route.query.id == this.$store.state.dataAccueil[0].id){
      this.$router.push('infoprofil')
    }

    if(Object.keys(this.$store.state.viewProfil).length > 0){
      this.user = this.$store.state.viewProfil
      this.axios.get(this.requestHttp + 'check_view_profil/' +route.query.id, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
        },
      }).then(({ data }) => {
        this.verifAbonnement = data[0]
        this.verifCommande = data[1]
        this.loadingVerify = true
      })
      .catch((error) => {
        console.log(error)
      });
    }else{
      this.axios.get(this.requestHttp + 'viewprofil/' + route.query.id, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
        },
      }).then(({ data }) => {
        this.user = data[0]
        this.$store.state.viewProfil = data[0]
        this.verifAbonnement = data[1]
        this.verifCommande = data[2]
        this.loadingVerify = true
      })
      .catch((error) => {
        console.log(error)
      });
    }

    
  },
  methods: {
    Abonnement(e) {
      this.axios.post(this.requestHttp + 'suivre/' + this.user.id,{}, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
        },
      }).then(() => {
        this.verifAbonnement = true
      })
      .catch((error) => {
        console.log(error)
      });
    },
    Desabonnee(){
      this.axios.delete(this.requestHttp + 'desabonnee/' + this.user.id, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
        },
      }).then(() => {
        this.verifAbonnement = false  
        this.showDesabonnee = false
      })
      .catch((error) => {
        console.log(error)
      });
    },
    Note(value){
      this.verifCommande = false 
      this.axios.post(this.requestHttp + 'note_boutique/' + this.user.id,{note: value, ville: this.user.ville}, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`
        },
      }).then(({ data }) => {
        this.user.etoile += value
        this.user.avis += 1
        this.$store.state.boutiques.filter((item, index) => item.id == this.user.id ? (this.$store.state.boutiques[index].etoile += value, this.$store.state.boutiques[index].avis += 1) : '')
      })
      .catch((error) => {
        console.log(error)
      });
    },
  },
  computed: {
    requestAuth() {
      return this.$store.state.auth
    },
    requestHttp() {
      return this.$store.state.api
    },
    requestAccueil() {
      return this.$store.state.dataAccueil
    },
    requestFile() {
      return this.$store.state.apifile
    },
  }
}
</script>

<style scoped>
.link .router-link-active {
  background-color: rgb(180 109 2 / var(--tw-bg-opacity));
  color: #FF9900;
}

:root {
  --tx: 0;
  --ty: 0;
}

.transition-next {
  animation: transitLeft 3s;
  transform: translateX(var(--ty));
}

@keyframes transitLeft {
  0% {
    transform: translateX(0)
  }

  100% {
    transform: translateX(var(--ty))
  }
}

.preview-transition {
  animation: transitRight 3s;
  transform: translateX(var(--ty))
}

@keyframes transitRight {
  0% {
    transform: translateX(0)
  }

  100% {
    transform: translateX(var(--ty))
  }
}

.typing {
  animation: Typing 0.7s infinite;
}

@keyframes Typing {
  0% {
    visibility: hidden;
  }

  50% {
    visibility: hidden;
  }

  100% {
    visibility: inherit;
  }
}

.rotation {
  animation: rotateBtn 2s infinite;
  transform: rotate(360deg);
}

@keyframes rotateBtn {
  0% {
    transform: rotate(360deg)
  }

  100% {
    transform: rotate(0deg)
  }
}

.stoprotation {
  animation: rotateStop 2s;
  transform: rotate(0deg);
}

@keyframes rotateStop {
  0% {
    transform: rotate(360deg)
  }

  100% {
    transform: rotate(0deg)
  }
}
</style>
